<template>
  <div id="contactInformation">
    <ul>
      <li class="telphone" :class="{'white':ishover[0],'pitch':!ishover[0]}" @mouseenter="showhover(0,true)" @mouseleave="showhover(0,false)">
        <img :src="img1" alt="">
        <img src="https://xuyuweb.oss-cn-shanghai.aliyuncs.com/gw/images/kuaijie_dianhua.png" alt="" style="position:absolute;top:10px;right:90px;" v-show="blo1">
      </li>
      <li class="weixin" :class="{'white':ishover[1],'pitch':!ishover[1]}" @mouseenter="showhover(1,true)" @mouseleave="showhover(1,false)">
        <img :src="img2" alt="">
        <img src="https://xuyuweb.oss-cn-shanghai.aliyuncs.com/gw/images/kuaijie_weixin.png" alt="" style="position:absolute;top:10px;right:90px;" v-show="blo2">
      </li>
      <li class="xiazai white" @click="download">
        下载
      </li>
    </ul>
    <div class="backTop" :class="{'white':ishover[2],'pitch':!ishover[2]}" @mouseenter="showhover(2,true)" @mouseleave="showhover(2,false)" @click="backTop" v-show="show">
      <img :src="img3" alt="">
    </div>
  </div>
</template>

<script>
export default {
  props: {

  },
  data () {
    return {
      ishover: [true, true, true],
      img1: 'https://xuyuweb.oss-cn-shanghai.aliyuncs.com/gw/images/kuaijie_dianhua_1.png',
      img2: 'https://xuyuweb.oss-cn-shanghai.aliyuncs.com/gw/images/kuaijie_weixin_1.png',
      img3: 'https://xuyuweb.oss-cn-shanghai.aliyuncs.com/gw/images/kuaijie_zhiding_1.png',
      blo1: false,
      blo2: false,
      scroll: 0,
      show: false,
      speed_: 100000
    };
  },
  mounted () {
    window.addEventListener('scroll', this.handleScroll)
  },
  methods: {
    showhover (i, bloo) {
      this.ishover[i] = !this.ishover[i]
      if (bloo)      {
        if (i == 0)        {
          this.img1 = 'https://xuyuweb.oss-cn-shanghai.aliyuncs.com/gw/images/kuaijie_dianhua_2.png'
          this.blo1 = true
        } else if (i == 1)        {
          this.img2 = 'https://xuyuweb.oss-cn-shanghai.aliyuncs.com/gw/images/kuaijie_weixin_2.png'
          this.blo2 = true
        } else        {
          this.img3 = 'https://xuyuweb.oss-cn-shanghai.aliyuncs.com/gw/images/kuaijie_zhiding_2.png'
        }
      } else      {
        if (i == 0)        {
          this.img1 = 'https://xuyuweb.oss-cn-shanghai.aliyuncs.com/gw/images/kuaijie_dianhua_1.png'
          this.blo1 = false
        } else if (i == 1)        {
          this.img2 = 'https://xuyuweb.oss-cn-shanghai.aliyuncs.com/gw/images/kuaijie_weixin_1.png'
          this.blo2 = false
        } else        {
          this.img3 = 'https://xuyuweb.oss-cn-shanghai.aliyuncs.com/gw/images/kuaijie_zhiding_1.png'
        }
      }

      this.$forceUpdate()//强制更新dom
      event.stopPropagation(); //1.停止事件冒泡，但是不会阻止默认行为
    },
    backTop () {
      let timer = setInterval(() => {
        let cur = document.documentElement.scrollTop || document.body.scrollTop;
        if (cur > 0)        {
          var speed = (0 - cur) / 10;
          speed = speed > 0 ? Math.ceil(speed) : Math.floor(speed);
          if (cur < this.speed_)          {
            this.speed_ = cur
            document.documentElement.scrollTop = cur + speed;
            document.body.scrollTop = cur + speed;
          } else          {
            clearInterval(timer)
            this.speed_ = 100000
          }
        } else        {
          this.$nextTick(() => {
            this.show = false
          })
          clearInterval(timer)
          this.speed_ = 100000
        }
      }, 20);
    },
    handleScroll () {
      this.scroll = window.pageYOffset || document.body.scrollTop || document.documentElement.scrollTop
      if (this.scroll > 0)      {
        this.show = true
      } else      {
        this.show = false
      }
    },
    download () {
      window.open('https://xuyuweb.oss-cn-shanghai.aliyuncs.com/Officialwebsite/download/AutoCAD%202020%E4%B8%80%E9%94%AE%E5%AE%89%E8%A3%85%E7%89%88%E3%80%90%E6%8E%A8%E8%8D%90%E5%AE%89%E8%A3%85%E3%80%91%EF%BC%88%E8%A7%A3%E5%8E%8B%E5%B8%A6%E6%95%99%E7%A8%8B%EF%BC%89.zip')
    }
  },
  components: {

  },
};
</script>

<style scoped>
#contactInformation ul {
  position: fixed;
  right: 10px;
  bottom: 382px;
  z-index: 9999;
}
#contactInformation div {
  position: fixed !important;
  right: 10px;
  bottom: 270px;
  z-index: 9999;
}
#contactInformation div,
li {
  border-radius: 10px;
  width: 60px;
  height: 60px;
  display: flex;
  align-items: center;
  justify-content: center;
  position: relative;
  margin-top: 8px;
  cursor: pointer;
}

#contactInformation div img,
li img:nth-of-type(1) {
  display: inline-block;
  transform: scale(70%);
}
.white {
  background: rgba(255, 255, 255, 0.8);
}
.pitch {
  background: rgba(0, 108, 251, 0.8);
}
.xiazai{
  color: rgba(0, 108, 251, 0.8);
}
.xiazai:hover{
  background: rgba(0, 108, 251, 0.8);
  color: white;
}
</style>



// WEBPACK FOOTER //
// src/components/contactInformation.vue